import assert from '@/sui/tools/assert'

import moment from 'moment'

function getElapsed (first, second, unit) {
  assert.isString(first)
  assert.isString(second)
  assert.isString(unit)

  const mf = moment(first, 'DD/MM/YYYY')
  if (mf.year() === 1) {
    return null
  }

  const ms = moment(second, 'DD/MM/YYYY')
  if (ms.year() === 1) {
    return null
  }

  return mf.diff(ms, unit)
}

export default {
  tostr: function (d, f) {
    const format = `DD/MM/YYYY${f ? ' hh:mm' : ''}`
    return moment(new Date(d)).format(format)
  },

  getElapsed
}
